import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "badge text-bg-warning fs-13 me-5 mt-10"
}
const _hoisted_9 = {
  key: 1,
  class: "badge text-bg-info fs-13 me-5 mt-10"
}
const _hoisted_10 = {
  key: 2,
  class: "badge text-bg-primary fs-13 me-5 mt-10"
}
const _hoisted_11 = {
  key: 3,
  class: "badge text-bg-success fs-13 me-5 mt-10"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 0,
  class: "flaticon-chat-1 text-danger"
}
const _hoisted_14 = { style: {"color":"#f08016"} }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { key: 5 }
const _hoisted_18 = { key: 6 }
const _hoisted_19 = { key: 7 }
const _hoisted_20 = { class: "dropdown" }
const _hoisted_21 = { class: "dropdown-menu" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { key: 8 }
const _hoisted_26 = {
  class: "modal fade",
  id: "chatClaimModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_27 = { class: "modal-dialog modal-xl" }
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = { class: "modal-body" }
const _hoisted_30 = {
  class: "modal fade",
  id: "infosClaimModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_31 = { class: "modal-dialog modal-lg" }
const _hoisted_32 = { class: "modal-content" }
const _hoisted_33 = { class: "modal-body" }
const _hoisted_34 = { class: "form-group mb-3" }
const _hoisted_35 = {
  key: 0,
  class: "form-group mb-3"
}
const _hoisted_36 = {
  key: 1,
  class: "form-group mb-3"
}
const _hoisted_37 = {
  key: 2,
  class: "form-group mb-3"
}
const _hoisted_38 = {
  key: 3,
  class: "form-group mb-3"
}
const _hoisted_39 = {
  key: 4,
  class: "form-group mb-3"
}
const _hoisted_40 = {
  key: 5,
  class: "form-group mb-3"
}
const _hoisted_41 = { class: "form-group mb-3" }
const _hoisted_42 = { class: "form-group mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_ChatClaim = _resolveComponent("ChatClaim")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/add-claims",
            class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
            type: "button"
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 top-2 fs-15" }, null, -1),
              _createTextVNode(" Nouvelle Réclamation ", -1)
            ])),
            _: 1,
            __: [13]
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Search ",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter())),
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.headers,
          rows: _ctx.rows
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode("Aucune entrées correspondantes trouvées", -1)
              ])),
              _: 1,
              __: [14]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field == 'created_at')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
              : (props.column.field === 'statut')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    (props.row.statut == 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " En cours de traitement "))
                      : _createCommentVNode("", true),
                    (props.row.statut == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Réponse service "))
                      : _createCommentVNode("", true),
                    (props.row.statut == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Réponse client "))
                      : _createCommentVNode("", true),
                    (props.row.statut == 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Réclamation traitée "))
                      : _createCommentVNode("", true)
                  ]))
                : (props.column.field === 'object')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createTextVNode(_toDisplayString(props.row.object) + " ", 1),
                      (_ctx.getLastMsg(props.row.messages[0]))
                        ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                        : _createCommentVNode("", true),
                      _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("small", _hoisted_14, [
                        _createTextVNode(_toDisplayString(props.row.code_colis) + " ", 1),
                        (props.row.new_price)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[15] || (_cache[15] = _createTextVNode(" - ", -1)),
                              _createElementVNode("b", null, _toDisplayString(props.row.new_price), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (props.row.new_price_remb)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[16] || (_cache[16] = _createTextVNode(" - ", -1)),
                              _createElementVNode("b", null, _toDisplayString(props.row.new_price_remb), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (props.column.field === 'city')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(props.row.city?.city), 1))
                    : (props.column.field === 'created_at')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          _createElementVNode("h5", null, _toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                          (props.row.taken_by_name && props.row.taken_by_name != '')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[18] || (_cache[18] = _createTextVNode(" Pris par: ", -1)),
                                _createElementVNode("span", null, _toDisplayString(props.row.taken_by_name), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : (props.column.field === 'last_response_by_name')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                            _createTextVNode(_toDisplayString(props.row.last_response_by_name), 1),
                            _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("small", null, _toDisplayString(_ctx.getDate(props.row.response_time)), 1)
                          ]))
                        : (props.column.field === 'code_colis')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(props.row.code_colis), 1))
                          : (props.column.field === 'action')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  _cache[22] || (_cache[22] = _createElementVNode("button", {
                                    class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                                    type: "button",
                                    "data-bs-toggle": "dropdown",
                                    "aria-expanded": "false"
                                  }, [
                                    _createElementVNode("i", { class: "flaticon-dots" })
                                  ], -1)),
                                  _createElementVNode("ul", _hoisted_21, [
                                    _createElementVNode("li", null, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item d-flex align-items-center",
                                        href: "javascript:void(0);",
                                        onClick: _withModifiers(($event: any) => (_ctx.showUpdate(props.row)), ["prevent"])
                                      }, _cache[20] || (_cache[20] = [
                                        _createElementVNode("i", { class: "ph ph-chat-circle-dots lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Conversation ", -1)
                                      ]), 8, _hoisted_22)
                                    ]),
                                    (props.row.statut !== 3)
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item d-flex align-items-center",
                                            href: "javascript:void(0);",
                                            onClick: ($event: any) => (_ctx.showDetails(props.row))
                                          }, _cache[21] || (_cache[21] = [
                                            _createElementVNode("i", { class: "flaticon-info lh-1 me-8 position-relative top-1" }, null, -1),
                                            _createTextVNode(" Informations ", -1)
                                          ]), 8, _hoisted_24)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users,
          offset: 9,
          onPaginate: _ctx.fetchData
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Conversation réclamation"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_ChatClaim, {
              messages: _ctx.chatMsgs,
              fetchMessages: _ctx.fetchMessages,
              rowClaim: _ctx.showClaim
            }, null, 8, ["messages", "fetchMessages", "rowClaim"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Informations réclamation"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _cache[24] || (_cache[24] = _createElementVNode("label", { for: "object" }, "Object", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "object",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formClaim.object) = $event)),
                disabled: "",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.formClaim.object]
              ])
            ]),
            _cache[34] || (_cache[34] = _createElementVNode("hr", null, null, -1)),
            (
                [
                  'Changement de prix',
                  'Relance Colis/Client',
                  'Annulation Colis',
                ].includes(_ctx.formClaim.object)
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { for: "colis" }, "Colis", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "colis",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formClaim.code_colis) = $event)),
                    disabled: "",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.formClaim.code_colis]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.formClaim.object === 'Changement Adresse/Client')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", null, [
                    _cache[26] || (_cache[26] = _createElementVNode("label", { for: "colis" }, "Colis", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "colis",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formClaim.code_colis) = $event)),
                      disabled: "",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.formClaim.code_colis]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.formClaim.object === 'Changement de prix')
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { for: "price" }, "Nouveau Prix", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "price",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formClaim.new_price) = $event)),
                    disabled: "",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.formClaim.new_price]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.formClaim.object === 'Rembourssement')
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { for: "price_remb" }, "Nouveau Prix", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "price_remb",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formClaim.new_price_remb) = $event)),
                    disabled: "",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.formClaim.new_price_remb]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(
                _ctx.formClaim.object === 'Changement Adresse/Client'
                  ? 'form-group mb-3'
                  : 'form-group mb-3'
              )
            }, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { for: "city" }, "Ville", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "city",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formClaim.city_name) = $event)),
                disabled: "",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.formClaim.city_name]
              ])
            ], 2),
            (_ctx.formClaim.object === 'Changement Adresse/Client')
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { for: "adresse" }, "Adresse", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    id: "adresse",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formClaim.adresse) = $event)),
                    rows: "3",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.formClaim.adresse]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(
                _ctx.formClaim.object === 'Changement Adresse/Client'
                  ? 'form-group mb-3'
                  : 'form-group mb-3'
              )
            }, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { for: "comment" }, "Commentaire", -1)),
              _withDirectives(_createElementVNode("textarea", {
                id: "comment",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formClaim.msg) = $event)),
                rows: "3",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.formClaim.msg]
              ])
            ], 2),
            (_ctx.formClaim.object === 'Changement Adresse/Client')
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _cache[32] || (_cache[32] = _createElementVNode("label", { for: "new_receiver" }, "Nouveau Client", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "new_receiver",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formClaim.new_receiver) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.formClaim.new_receiver]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", { for: "new_phone" }, "Téléphone", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "new_phone",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formClaim.new_phone) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.formClaim.new_phone]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ")
          ], -1))
        ])
      ])
    ])
  ], 64))
}